import {useState} from "react";
import {Switch} from "antd";

const SwitchTraining = ({item, toggleTraining}) =>
{
    const [toggleLoading, setToggleLoading] = useState(false);

    function training(checked)
    {
        setToggleLoading(true);

        toggleTraining(item, checked ? 1 : 0).finally(() => {
            setToggleLoading(false);
        });
    }

    return (<div className="d-flex align-items-center mt-1">
        <Switch size="small" checked={item?.isTraining === 1} loading={toggleLoading} onChange={training} />
    </div>);
}

export default SwitchTraining;